<template>
  <StandardResourceService
    v-model="activeTab" :tab-list="tabList" title="大横琴">
    <OrderRecordsComponent v-if="activeTab==='orderRecord'"></OrderRecordsComponent>
    <ProductUpdateComponent v-else-if="activeTab==='productUpdate'"></ProductUpdateComponent>
    <AssociatedAccountComponent v-else-if="activeTab==='linkAccount'"></AssociatedAccountComponent>
    <HotelPriceRuleComponent v-else-if="activeTab==='priceRule'"></HotelPriceRuleComponent>
  </StandardResourceService>
</template>
<script>
import ProductUpdateComponent from '@/views/resource/dahengqin/components/ProductUpdateComponent.vue'
import OrderRecordsComponent from '@/views/resource/dahengqin/components/OrderRecordsComponent.vue'
import AssociatedAccountComponent from '@/views/resource/dahengqin/components/AssociatedAccountComponent.vue'
import HotelPriceRuleComponent from '@/views/resource/dahengqin/components/HotelPriceRuleComponent.vue'
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'

export default {
  name: 'DaHengQinHome',
  components: {
    AssociatedAccountComponent,
    HotelPriceRuleComponent,
    StandardResourceService,
    OrderRecordsComponent,
    ProductUpdateComponent
  },
  data() {
    return {
      activeTab: 'orderRecord',
      tabList: [
        { label: '订单记录', key: 'orderRecord' },
        { label: '产品更新', key: 'productUpdate' },
        { label: '关联账号', key: 'linkAccount' },
        { label: '酒店改价规则', key: 'priceRule' }
      ]
    }
  }
}
</script>

